// ======================
// MigrateOpsWizardGetStartedStep
// ======================

import { Alert, Box, Stack, Typography } from "@mui/material";
import React from "react";
import { SlideAndFadeInStep, StepperNavButtons } from "../../../common/stepper/StepperComponents";
import { useStepperContext } from "../../../common/stepper/StepperState";
import { useTranslation } from "react-i18next";

interface MigrateOpsWizardGetStartedStepProps {
    goToNextStepFn?: () => void;
    id: string;
}

export const MigrateOpsWizardGetStartedStep: React.FC<MigrateOpsWizardGetStartedStepProps> = (p) => {
    const { t } = useTranslation("migrateops");
    const { goToNextStepFn, id } = p;
    const activeStep = useStepperContext((s) => s.activeStep);
    const stepConfigs = useStepperContext((s) => s.stepConfigs);
    return (
        <SlideAndFadeInStep transitionIn={stepConfigs[activeStep].id === id}>
            <Stack direction={"column"} spacing={6}>
                <Stack direction={"column"} justifyContent={"center"} alignItems={"center"} spacing={2} pl={6} pr={6}>
                    <Typography variant={"h2"}>{t("wizard.getStarted.title")}</Typography>
                    <Typography variant={"body1"} textAlign={"center"}>
                        {t("wizard.getStarted.description")}
                    </Typography>
                </Stack>
                <Box pl={6} pr={6}>
                    <Alert severity={"info"}>{t("wizard.getStarted.limits")}</Alert>
                </Box>
                <Box>
                    <StepperNavButtons nextButtonProps={goToNextStepFn ? { onClick: goToNextStepFn } : undefined} />
                </Box>
            </Stack>
        </SlideAndFadeInStep>
    );
};
